export const coursePerformanceAnalyticsHeader = [
  { field: 'course_name', headerName: 'Course', width: 250, sortable: true, toolTipGetter: true },

  { field: 'active_students_from_date', headerName: 'Active Students on From Date', width: 260, sortable: true },
  { field: 'paying_students', headerName: 'Paying Students', width: 160, sortable: true },
  { field: 'active_tutors_from_date', headerName: 'Active Tutors on From Date', width: 260, sortable: true },
  { field: 'student_tutor_ratio', headerName: 'Student Tutor Ratio', width: 230, sortable: true },

  { field: 'revenue', headerName: 'Revenue', width: 140, sortable: true },
  { field: 'arpu', headerName: 'ARPU', width: 120, sortable: true },
  { field: 'arppu', headerName: 'ARPPU', width: 120, sortable: true },

  { field: 'total_tp', headerName: 'Total TP', width: 120, sortable: true },
  { field: 'sessions_held', headerName: 'Sessions Held', width: 160, sortable: true },
  { field: 'average_tp', headerName: 'Average TP', width: 140, sortable: true },

  { field: 'gross_profit', headerName: 'Gross Profit', width: 160, sortable: true },
  { field: 'gross_margin', headerName: 'Gross Margin', width: 160, sortable: true },

  { field: 'paying_student_rate', headerName: 'Paying Student Rate', width: 230, sortable: true },
  { field: 'tc_uploaded', headerName: 'TC Uploads', width: 170, sortable: true },

  {
    field: 'temp_inactive_to_active',
    headerName: 'No. of Reactivations from Inactive',
    width: 300,
    sortable: true,
  },
  { field: 'temp_inactive_to_inactive', headerName: 'No. of TCs from Inactive', width: 240, sortable: true },

  { field: 'active_students_to_date', headerName: 'Active Students on To Date', width: 250, sortable: true },
  { field: 'active_tutors_to_date', headerName: 'Active Tutors on To Date', width: 220, sortable: true },
];
